<template>
  <div class="location-input">
    <MenuLabel
      :label="$t('STAY_LOCATION_HEADER')"
      :isOpen="isOpen"
      :value="selectedLocation.name"
      :first="true"
      @toggle="handleMenuToggled"
    />
    <component
      :is="$device.isMobile ? 'Drawer' : 'DropdownMenu'"
      :visible="isOpen"
      class="location-input__menu-container"
      ref="dropdownMenu"
      :title="$t('STAY_LOCATION_HEADER')"
      @close="handleMenuToggled"
    >
      <ul
        v-for="{ region, venues } in locations"
        :key="region"
        class="location-input__accordion-wrapper"
      >
        <AccordionItem
          :isDrawerItem="$device.isMobile"
          :isDropdownItem="!$device.isMobile"
          type="arrow"
          :ref="region"
          @toggle="handleLocationToggled(region)"
        >
          <template #header>
            <div>{{ $t(`REGION_LABEL_${region}`) }}</div>
          </template>
          <template #content>
            <MenuItem
              v-for="location in venues"
              :key="location.index"
              :label="location.name"
              :value="location.id"
              :selected="location.id === selectedLocation.id"
              :imgSrc="location.icons.darkSvg"
              :isDisabled="locationIsMembersOnly(location.hotel.publicAccess) && !userIsMember"
              @click="handleMenuItemClicked(location)"
            >
              <template v-if="locationIsMembersOnly(location.hotel.publicAccess) && !userIsMember" #supporting-text>
                <span class="location-input__members-only-label">{{ $t('STAY_BROWSE_MEMBERS_ONLY_HOUSE_LABEL') }}</span>
              </template>
            </MenuItem>
          </template>
        </AccordionItem>
      </ul>
      <template v-if="$device.isMobile" #footer>
        <ShButton @click="handleMenuToggled" :fullWidth="true" :disabled="!Boolean(selectedLocation.id)">
          {{ $t('STAY_MODIFY_BOOKING_CONFIRM_CTA') }}
        </ShButton>
      </template>
    </component>
  </div>
</template>

<script>
import {
  DropdownMenu,
  MenuItem,
  MenuLabel,
  AccordionItem,
  Drawer
} from '@sohohouse/design-system'
import get from '~/helpers/get'
import { bookingConstants } from '../../menuConfig'

export default {
  name: 'BedroomsLocationMenu',
  components: {
    AccordionItem,
    DropdownMenu,
    MenuItem,
    MenuLabel,
    Drawer
  },

  props: {
    selectedLocation: {
      type: Object,
      default: () => ({
        label: '',
        id: ''
      })
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    locations: {
      type: Array,
      required: true
    },
    userIsMember: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    accordionRefKeys () {
      return Object.keys(this.$refs).filter((key => Array.isArray(this.$refs[key])))
    }
  },

  methods: {
    handleLocationToggled (toggledLocation) {
      // Scrolls menu back to the top
      this.$refs.dropdownMenu.$el.scrollTop = 0

      // Closes the location accordion
      // that is open
      this.accordionRefKeys.forEach(locationName => {
        const [accordion] = this.$refs[locationName]
        if (toggledLocation !== locationName && get(accordion, '$data.openState')) {
          accordion.$data.openState = false
        }
      })
    },
    handleMenuToggled () {
      if (this.isOpen) {
        this.accordionRefKeys.forEach(locationName => {
          const [accordion] = this.$refs[locationName]
          if (get(accordion, '$data.openState')) {
            accordion.$data.openState = false
          }
        })
      }
      return this.$emit('menuToggle')
    },
    handleMenuItemClicked (location) {
      return this.$emit('itemSelected', location)
    },
    locationIsMembersOnly (publicAccess) {
      return publicAccess === bookingConstants.MEMBERS_ONLY_HOUSE_VALUE
    }
  }
}
</script>

<style lang="scss" scoped>
$menu-border: 1px solid $color-gray-5;
$menu-dropdown-max-height: 60vh;

.location-input {

  &__menu-container {
    @include tablet {
      padding-bottom: $space-050;
      max-height: $menu-dropdown-max-height;
      overflow-y: scroll;
    }
  }

  &__accordion-wrapper {
    margin: 0;
    padding: 0;
  }

  &__members-only-label {
    color: $color-gray;
  }
}
</style>
